import { Uppy } from '@uppy/core';
import { App, Image, ImageContent, Thresholds } from '@types';
// needs to use common style import?
const XHRUpload = require('@uppy/xhr-upload');
import { GlobalCtxProps } from '@components/globalContext';
import { Server } from '@utils';

const UPPY_RESTRICTIONS = {
  maxNumberOfFiles: 1,
  maxFileSize: 5242880, // 5MB. See also PREVIEW_BYTE_THRESHOLD
};

interface CreateInstanceArgs {
  app: App;
  image: Image;
  onUploadComplete: (props: ImageContent) => void;
  onUploadStart: () => void;
  onUploadError: (errorMessage?: string) => void;
}
const UppyHelpers = {
  createInstance: ({
    app,
    image,
    onUploadStart,
    onUploadComplete,
    onUploadError,
  }: CreateInstanceArgs) => {
    const instance = new Uppy({
      id: 'uppy1',
      autoProceed: true,
      restrictions: UPPY_RESTRICTIONS,
      // debug: true,
      onBeforeUpload: (files) => {
        onUploadStart();
        return files;
      },
    });

    instance.use(XHRUpload, {
      headers: {
        'X-CSRF-Token': Server.getVar('APP_TOKEN'),
      },
      endpoint: '/upload',
      formData: true,
      getResponseError: (responseText) => {
        const error = JSON.parse(responseText).error;
        onUploadError(error?.message);
      },
    });

    instance.setMeta({
      bandwidth: app.bandwidth,
      clientId: app.clientId,
      high: app.thresholds.high,
      low: app.thresholds.low,
    });

    instance
      .on('upload-success', (file, response) => {
        const { status, body } = response;
        if (status === 201) {
          onUploadComplete({
            filename: body.filename,
            mod: body.mod,
            previewMod: body.previewMod,
            previewSrc: body.previewSrc,
            src: body.src,
          });
        }
      })
      .on('file-added', (file) => {
        instance.setFileMeta(file.id, {
          size: file.size,
        });
      })
      .on('restriction-failed', (file, error) => {
        onUploadError(error?.message);
      });
    // There are other 'upload-error' named events, but we are
    // handling above via getResponseError()
    return instance;
  },
};

export default UppyHelpers;
